import {
	IConsultaResumoExtratoForm,
	IConsultaResumoExtratoBaseEstadualRequestType,
} from 'store/modules/api/detranCrv/ConsultarResumoExtrato/types';

import * as Yup from 'yup';

export const initialValues: IConsultaResumoExtratoForm = {
	placa: '',
	chassi: '',
	documento: '',
	renavam: '',
	selecao: 'placa',
	ufVeiculo: 'SP',
};

export function treatValues(
	values: IConsultaResumoExtratoForm,
): IConsultaResumoExtratoBaseEstadualRequestType {
	const { placa, chassi, documento, renavam, selecao } = values;

	const tipoSelecao = {
		placa: { pepm: 1, pgat: 1, pcov: 1, txut: 1 },
		renavam: {
			pepm: 2,
			pgat: 3,
			pcov: 3,
			txut: 2,
		},
		chassi: {
			pepm: 3,
			pgat: 2,
			pcov: 2,
			txut: 2,
		},
		none: { pepm: 0, pgat: 0, pcov: 0, txut: 0 },
	};

	const tipoSelecionado = tipoSelecao[selecao || 'none'];

	return {
		pepm: {
			tipoPesquisa: tipoSelecionado.pepm,
			chassi,
			placa,
			renavam: renavam || '',
		},
		pgat: {
			tipoPesquisa: tipoSelecionado.pgat,
			chassi,
			placa,
		},
		pcov: {
			tipoPesquisa: tipoSelecionado.pcov,
			chassi,
			placa,
			renavam: renavam || '',
		},
		txut: {
			tipoPesquisa: tipoSelecionado.txut,
			placa,
			renavam: renavam || '',
			cpfCnpj: documento || '',
			codBanco: null,
			nsuProdesp: null,
			dataContabil: null,
		},
	};
}

export const schema = Yup.object<IConsultaResumoExtratoForm>().shape({
	validatePlaca: Yup.string().when(['placa', 'selecao'], {
		is: (placa, selecao) =>
			selecao === 'placa' &&
			(placa === '' || (placa !== '' && placa.length !== 7)),
		then: Yup.string().required(`Campo Obrigatório: Placa.`),
	}),
	validateChassi: Yup.string().when(['chassi', 'selecao'], {
		is: (chassi, selecao) =>
			selecao === 'chassi' &&
			(chassi === '' || (chassi !== '' && chassi.length < 17)),
		then: Yup.string().required(`Campo Obrigatório: Chassi.`),
	}),
	validateRenavam: Yup.string().when(['renavam', 'selecao'], {
		is: (renavam, selecao) => selecao === 'chassi' && renavam === '',
		then: Yup.string().required(`Campo Obrigatório: Renavam.`),
	}),
});
